module.exports = __webpack_public_path__ + "static/media/sunwei_match_01.4390d883.png";